import React from "react";
import { Card } from "react-bootstrap";
import {INoticeDetails } from "../../../models/interfaces/INotice";

interface IProps {
    NoticeDetails: INoticeDetails;
}

const BlocLivreEnMain: React.FC<IProps> = ({ NoticeDetails }) => {
  
  // Check if all properties of NoticeDetails are empty, and if so, return null (render nothing)
  const isLivreEnMain = 
    NoticeDetails?.LivreEnMain;

  if (!isLivreEnMain) {
    return null;
  }

  return (
    <>
      <Card>
        <Card.Body>
          {isLivreEnMain && (
            <div className="text-success fw-bold text-start">
            <i className="bi bi-trophy-fill"></i> Ouvrage contrôlé livre en main par Electre.
          </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default BlocLivreEnMain;
